import Vue from 'global-vue'

import LoggerActionGrid from 'app/components/ui/LoggerActionGrid.vue'
import ComplexFilterPanel from 'app/components/ui/ComplexFilterPanel.vue'
import DateInput from 'app/components/ui/DateInput.vue'
import AppSwitcher from 'app/components/ui/AppSwitcher.vue'

import clickOutside from 'app/directives/clickOutside'

export default class {

    run(){

        Vue.component('logger-action-grid', LoggerActionGrid);
        Vue.component('complex-filter-panel', ComplexFilterPanel);
        Vue.component('date-input', DateInput);
        Vue.component('app-switcher', AppSwitcher);

        Vue.directive('app-click-outside', clickOutside);
    }
}